export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9518.4f9c4794.jpg";